/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol__ = _interopDefault(require('openlayers'));
var minilo = require('../util/minilo');
var format = require('./format');

var Feature = __ol__.Feature;
var geoJsonFmt = format.createGeoJsonFmt();

/**
 * @param {ol.Feature} feature
 * @param {ol.ProjectionLike|undefined} [featureProjection]
 * @param {ol.ProjectionLike|undefined} [dataProjection]
 * @return {GeoJSONFeature|Object}
 */
function writeGeoJsonFeature(feature, featureProjection, dataProjection) {
  var geoJsonFeature = geoJsonFmt.writeFeatureObject(feature, { featureProjection: featureProjection, dataProjection: dataProjection });

  if (Array.isArray(minilo.get(geoJsonFeature, 'properties.features'))) {
    geoJsonFeature.properties.features = geoJsonFeature.properties.features.map(function (feature) {
      if (feature instanceof Feature) {
        return writeGeoJsonFeature(feature, featureProjection, dataProjection);
      }
      return feature;
    });
  }

  return geoJsonFeature;
}

/**
 * @param {GeoJSONFeature|Object} geoJsonFeature
 * @param {ol.ProjectionLike|undefined} [featureProjection]
 * @param {ol.ProjectionLike|undefined} [dataProjection]
 * @return {ol.Feature}
 */
function readGeoJsonFeature(geoJsonFeature, featureProjection, dataProjection) {
  var feature = geoJsonFmt.readFeature(geoJsonFeature, { featureProjection: featureProjection, dataProjection: dataProjection });

  if (Array.isArray(feature.get('features'))) {
    feature.set('features', feature.get('features').map(function (feature) {
      if (minilo.isPlainObject(feature)) {
        return readGeoJsonFeature(feature, featureProjection, dataProjection);
      }
      return feature;
    }));
  }

  return feature;
}

/**
 * @param {ol.geom.Geometry} geometry
 * @param {ol.ProjectionLike|undefined} [geometryProjection]
 * @param {ol.ProjectionLike|undefined} [dataProjection]
 * @return {GeoJSONGeometry|GeoJSONGeometryCollection|Object}
 */
function writeGeoJsonGeometry(geometry, geometryProjection, dataProjection) {
  return geoJsonFmt.writeGeometryObject(geometry, {
    featureProjection: geometryProjection,
    dataProjection: dataProjection
  });
}

/**
 * @param {GeoJSONGeometry|Object} geoJsonGeometry
 * @param {ol.ProjectionLike|undefined} [geometryProjection]
 * @param {ol.ProjectionLike|undefined} [dataProjection]
 * @return {ol.geom.Geometry}
 */
function readGeoJsonGeometry(geoJsonGeometry, geometryProjection, dataProjection) {
  dataProjection = readProjection(geoJsonGeometry, dataProjection);

  return geoJsonFmt.readGeometry(geoJsonGeometry, {
    featureProjection: geometryProjection,
    dataProjection: dataProjection
  });
}

function readProjection(geoJsonObj, defaultProjection) {
  return geoJsonFmt.readProjection(geoJsonObj) || defaultProjection;
}

exports.writeGeoJsonFeature = writeGeoJsonFeature;
exports.readGeoJsonFeature = readGeoJsonFeature;
exports.writeGeoJsonGeometry = writeGeoJsonGeometry;
exports.readGeoJsonGeometry = readGeoJsonGeometry;
exports.readProjection = readProjection;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/ol-ext/geojson.js
// module id = 523
// module chunks = 1